import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getAllMerchants = async () => {
  try {
    const res = await request.get(Constants.get_all_merchants_api_url);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const updateMerchant = async (merchant, data) => {
  try {
    const res = await request.patch(`${Constants.update_merchant_api_url}/${merchant}`, data);
    if (res?.status) {
      return res.data;
    }
  } catch (err) {
    throw err;
  }
};

export const searchMerchant = async (searchQuery) => {
  try {
    const res = await request.get(`${Constants.search_merchant_api_url}?query=${searchQuery}`);
    if (res?.status) {
      return res.data;
    }
  } catch (err) {
    throw err;
  }
};